import React from "react";
import MainNavbar from "../_includes/navbar/main-navbar";
import { Container } from "react-bootstrap";
import { stringJoin } from "../../../utils/functions";
import AgeGateComponent from "../_includes/age-gate-component/age-gate.component";
import { useAllBeers } from "../../queries/beer.queries";
import MainFooter from "../_includes/footer/main-footer";
import ConsentContext from "../../contexts/consent.context";

import * as LayoutStyles from "./default-layout.module.scss";

interface DefaultLayoutProps extends React.PropsWithChildren {
    bypassAgeGate?: boolean; // Setting `true` will prevent the AgeGate component from being rendered.
    // Used for legal-related pages; E.g. a person cannot consent to our Terms of Use without reading them first.
    style?: React.CSSProperties;
}

export const DefaultLayout: React.FC<DefaultLayoutProps> = (props) => {
    const { showAgeGate } = React.useContext(ConsentContext);

    const products = useAllBeers();
    return (
        <>
            {showAgeGate && !props.bypassAgeGate ? <AgeGateComponent /> : null}
            <main className="d-flex flex-column h-100" style={props.style}>
                <MainNavbar products={products} />
                <Container fluid className={stringJoin("w-100 flex-shrink-0 m-0", LayoutStyles.container)}>
                    {props.children}
                </Container>
                <MainFooter products={products} />
            </main>
        </>
    );
};

export default DefaultLayout;
